export default __webpack_public_path__ + "static/andy-c5acb6a4be4d6051f3c02effc36ac1b5.jpg";